import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import ReviewQueue from "@/pages/ReviewQueue";
import Research from "@/pages/Research";
import Designs from "@/pages/Designs";
import Listings from "@/pages/Listings";
import Ads from "@/pages/Ads";
import Analytics from "@/pages/Analytics";
import Wallet from "@/pages/Wallet";
import Stores from "@/pages/Stores";
import Settings from "@/pages/Settings";
import Billing from "@/pages/Billing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SquareSuccess from "@/pages/SquareSuccess";
import Vault from "@/pages/Vault";
import VaultOrderSuccess from "@/pages/VaultOrderSuccess";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#090B0E] text-slate-400">
        <span className="w-6 h-6 rounded-full border-2 border-emerald-500/40 border-t-emerald-400 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route path="/payment/square-success" element={<Protected><SquareSuccess /></Protected>} />
      <Route path="/vault/order-success" element={<Protected><VaultOrderSuccess /></Protected>} />
      <Route
        element={
          <Protected>
            <SettingsProvider>
              <Layout />
            </SettingsProvider>
          </Protected>
        }
      >
        <Route path="/" element={<Overview />} />
        <Route path="/vault" element={<Vault />} />
        <Route path="/queue" element={<ReviewQueue />} />
        <Route path="/research" element={<Research />} />
        <Route path="/designs" element={<Designs />} />
        <Route path="/listings" element={<Listings />} />
        <Route path="/ads" element={<Ads />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/billing" element={<Billing />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
